export interface TokenIdentity {
  name?: string;
  email?: string;
  /** The user id; a password-grant token carries nothing else about the user. */
  subject?: string;
}

/** base64url payload to text; atob yields bytes, and a name with diacritics is UTF-8. */
const decodePayload = (payload: string): string => {
  const bytes = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
  return decodeURIComponent(
    Array.from(bytes, c => `%${c.charCodeAt(0).toString(16).padStart(2, '0')}`).join(''),
  );
};

/** Who the bearer token says we are, for a screen that cannot ask the server. */
export const tokenIdentity = (bearer: string | undefined): TokenIdentity => {
  const payload = bearer?.replace(/^Bearer /, '').split('.')[1];
  if (!payload) return {};
  try {
    const claims: unknown = JSON.parse(decodePayload(payload));
    if (typeof claims !== 'object' || claims === null) return {};
    const read = (key: string): string | undefined => {
      if (!(key in claims)) return undefined;
      const value: unknown = Reflect.get(claims, key);
      return typeof value === 'string' ? value : undefined;
    };
    return {
      name: read('name') ?? read('preferred_username'),
      email: read('email'),
      subject: read('sub'),
    };
  } catch {
    return {};
  }
};
